$(document).ready(function () {
  Sceon.CompanyProfileListing = {};

  Sceon.CompanyProfileListing.Load = function () {
    let cp_overlay = new Sceon.Overlay($('main .sc-container'), {
      loader: '/img/loader-tiny.gif',
      offset: { bottom: 0, top: 0, left: '1px' },
    });
    cp_overlay.enable();

    let filter = Sceon.CompanyProfileListing.ParseHash();

    if (filter.name) {
      filter.name = filter.name.replace(/%20/g, ' ');
    }

    $('html, body').animate({ scrollTop: 0 }, 200);

    if (location.pathname.includes('/filter/swingerclub-schweiz')) {
      location.pathname = '/agencies';
      return;
    }

    $.ajax({
      method: 'POST',
      url: location.pathname,
      data: filter,
      success: function (resp) {
        if (resp) {
          $('.company-listing-container').replaceWith(resp);
        }
        cp_overlay.disable();

        Sceon.CompanyProfileListing.onPrClick(location.hash);
      },
      error: function (err) {
        console.error(err);
        cp_overlay.disable();
      },
    });
  };

  Sceon.CompanyProfileListing.Paginate = function (page) {
    Sceon.CompanyProfileListing.SetHash(
      Sceon.CompanyProfileListing.MakeHash({ page }),
    );
  };

  Sceon.CompanyProfileListing.GetFilters = function (params = {}) {
    let filters = {};
    $(document)
      .find('.agency-filter select:not([name="geo_node_id"])')
      .each((ind, el) => {
        let val = $(el).val();
        if (val.length && val != 'null') {
          filters[$(el).attr('name')] = val;
        }
      });

    let $textInput = $('.search-input');
    let text = $textInput.val();
    if (text.length) {
      filters.name = text;
    }

    let is_premium = $('#is_premium').is(':checked');
    if (is_premium) {
      filters.ip = true;
    }

    filters = {
      ...filters,
      ...params,
    };

    return filters;
  };

  Sceon.CompanyProfileListing.InitFilterChange = function () {
    $(document).on(
      'change',
      '.agency-filter select:not([name="geo_node_id"]), .agency-filter #is_premium',
      function () {
        if (event) {
          Sceon.CompanyProfileListing.SetHash(
            Sceon.CompanyProfileListing.MakeHash(),
          );
        }
      },
    );

    const searchInput = $(document).find('.agency-filter .search-input');
    let timer = null;
    if (searchInput.length) {
      searchInput
        .blur(function () {
          if ($(this).val().trim().length < 3) {
            $(this).val('');
          }
        })
        .keyup(function () {
          let val = $(this).val();
          clearTimeout(timer);
          timer = setTimeout(() => {
            if (val.length < 3) {
              $(this).val('');
            }
            Sceon.CompanyProfileListing.SetHash(
              Sceon.CompanyProfileListing.MakeHash(),
            );
          }, 500);
        });
    }

    $(document).on(
      'change',
      '.agency-filter select[name="geo_node_id"]',
      function () {
        if (event) {
          let hash = location.hash;
          console.log(hash, $(this).val());
          location.href = $(this).val();
        }
      },
    );
  };

  Sceon.CompanyProfileListing.onPrClick = function (hash) {
    let from = '';
    if (location.pathname.length > 10) {
      from = location.pathname.substring(10);
    }

    if (from.length > 0) {
      hash = `${hash}from=${from}`;
    }
    $(document)
      .unbind('click auxclick')
      .on(
        'click auxclick',
        '.agency-item .showname a, .agency-item .images a',
        function () {
          event.preventDefault();
          let href = $(this).attr('href');
          if (event.type == 'click') {
            location.href = `${href}?${hash}`;
          } else if (event.type == 'auxclick' && event.which !== 3) {
            window.open(`${href}?${hash}`);
          }
        },
      );
  };

  Sceon.CompanyProfileListing.SetFiltersFromHash = function () {
    let hash = location.hash.substring(1);
    if (hash.length > 0) {
      let objs = hash.split(';');
      objs.forEach((el) => {
        let name = el.split('=')[0];
        let val = el.split('=')[1];

        if (val) {
          val = val.replace(/%20/g, ' ');
        }

        if (name && val) {
          if ($(`[name=${name}]`).hasClass('form-check-input')) {
            $(`[name=${name}]`).prop('checked', true);
          }
          $(`[name=${name}]`).val(decodeURI(val));
          if ($(`[name=${name}]`).hasClass('sort-select')) {
            $(`[name=${name}]`).trigger('change');
          }
        }
      });
    }
  };

  Sceon.CompanyProfileListing.MakeHash = function (params = {}) {
    let filter = Sceon.CompanyProfileListing.GetFilters(params);
    let hash = '';
    for (let i in filter) {
      hash += `${i}=${filter[i]};`;
    }
    return hash;
  };

  Sceon.CompanyProfileListing.SetHash = function (hash) {
    if (hash.length) {
      document.location.hash = '#' + hash;
    } else {
      document.location.hash = '';
    }
    return false;
  };

  Sceon.CompanyProfileListing.ParseHash = function () {
    let hash = location.hash.substring(1);
    let filter = {};
    if (!hash.length) {
      return {};
    }
    let params = hash.split(';');
    for (let i in params) {
      let name = params[i].split('=')[0];
      let val = params[i].split('=')[1];
      if (name && val) {
        filter[name] = val;
      }
    }
    return filter;
  };

  Sceon.HashController = {
    _current: '',

    init: function () {
      window.onhashchange = function () {
        Sceon.HashController.check();
      };
      Sceon.HashController.check();
    },

    check: function () {
      let hash = document.location.hash.substring(1);

      if (hash !== this._current) {
        this._current = hash;
        Sceon.CompanyProfileListing.Load();
      }
    },
  };

  Sceon.CompanyProfileListing.InitFilterChange();
  Sceon.CompanyProfileListing.SetFiltersFromHash();

  Sceon.HashController.init();
});
